// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapUserLocation_wrapper__JKOKm","button":"MapUserLocation_button__1dKpO","spinner":"MapUserLocation_spinner__RPCwO"};